import { format, add, sub } from "date-fns";
import { Totals, CalcularResto } from "../../../functions/FunctionReportes";
import { CalcularRestoJudicial, TotalsJuicio } from "../../../functions/Validaciones/PagoJudicial";
import { FormatterNumber } from "../../../utils/formatter";
import "../../shared/styles/UnifiedTable.css";

const Tabla_pagos_judicial = ({ data, onClick }) => {
  const totales = TotalsJuicio(data);
  return (
    <div className="unified-table-container">
      <table className="unified-table" id="tabla_caja">
        <thead>
          <tr>
            <th className="text-center"><div>Id</div></th>
            <th className="text-start"><div>Judicial</div></th>
            <th className="text-start"><div>Cajero</div></th>
            <th className="text-start"><div>Punto de venta</div></th>
            <th className="text-start"><div>Cliente</div></th>
            <th className="text-center"><div>Fecha de importe</div></th>
            <th className="text-center"><div>Tipo de pago</div></th>
            <th className="text-center"><div>Tipo de importe</div></th>
            <th className="text-end"><div>Importe</div></th>
            <th className="text-end"><div>Interés Moratorio</div></th>
            <th className="text-end"><div>Monto</div></th>
          </tr>
        </thead>
        <tbody>
          {data.map((pago, index) => (
            <tr key={index}>
              <td className="text-center">{pago.id}</td>
              <td className="text-start">{pago.gasto.item}</td>
              <td className="text-start">
                {pago.cajero.name + " " + pago.cajero.lastname}
              </td>
              <td className="text-start">
                {pago.punto_venta
                  ? pago.punto_venta.nombre
                  : "Sin punto de venta"}
              </td>
              <td className="text-start">
                {pago.persona_nombre + " " + pago.persona_apellido}
              </td>
              <td className="text-center">
                {format(
                  new Date(pago.fecha_importe + " 00:00:00"),
                  "dd/MM/yyyy"
                )}
              </td>
              <td className="text-center">
                <span className="unified-badge unified-badge-info">
                  {pago.forma_pago}
                </span>
              </td>
              <td className="text-center">
                <span className={
                  pago.estado === 'TOTAL' ? 'unified-badge unified-badge-success' :
                  pago.estado === 'PARCIAL' ? 'unified-badge unified-badge-warning' :
                  pago.estado === 'EXCEDENTE' ? 'unified-badge unified-badge-info' :
                  'unified-badge unified-badge-secondary'
                }>
                  {pago.estado}
                </span>
              </td>
              <td className="text-end">
                <span className="unified-money">
                  {FormatterNumber(pago.importe)}
                </span>
              </td>
              <td className="text-end">
                <span className="unified-money">
                  {FormatterNumber(
                    CalcularRestoJudicial(pago).interes_punitorio < 0
                      ? pago.interes_moratorio
                      : pago.interes_moratorio - CalcularRestoJudicial(pago).interes_punitorio
                  )}
                </span>
              </td>
              <td className="text-end">
                <span className="unified-money">
                  {FormatterNumber(
                    CalcularRestoJudicial(pago).capital < 0
                      ? pago.monto
                      : pago.monto - CalcularRestoJudicial(pago).capital
                  )}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr style={{ background: 'linear-gradient(135deg, #F3F4F6 0%, #E5E7EB 100%)', fontWeight: 'bold' }}>
            <td colSpan={8} className="text-end" style={{ fontSize: '1.1rem', padding: '16px' }}>
              TOTAL
            </td>
            <td className="text-end" style={{ fontSize: '1.1rem', padding: '16px' }}>
              <span className="unified-money" style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>
                {FormatterNumber(totales.subTotal)}
              </span>
            </td>
            <td className="text-end" style={{ fontSize: '1rem', padding: '16px' }}>
              <div className="text-muted" style={{ fontSize: '0.75rem' }}>IM</div>
              <span className="unified-money">
                {FormatterNumber(totales.interes_punitorio)}
              </span>
            </td>
            <td className="text-end" style={{ fontSize: '1rem', padding: '16px' }}>
              <div className="text-muted" style={{ fontSize: '0.75rem' }}>MONTO</div>
              <span className="unified-money">
                {FormatterNumber(totales.capital)}
              </span>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default Tabla_pagos_judicial;
